import { useQuery } from 'react-query';

import { Tag } from '../types/tags';
import { fetchTags } from '../utils/tags';

export const useTags = () => {
  return useQuery<Tag[], Error>(['tags'], fetchTags);
};
